import React from 'react'
import { FormControl, FormHelperText, Select } from '@mui/material'
import type { SelectProps } from '@mui/material'
import FieldLabel from './FieldLabel'

export type LabeledSelectProps = Omit<SelectProps, 'label'> & {
  /** Caption rendered above the control (label-at-top convention). */
  label: React.ReactNode
  /** Append a ` *` marker to the label and mark the control required. */
  required?: boolean
  /** Helper text under the control. */
  helperText?: React.ReactNode
  /** The `<MenuItem>`s. */
  children: React.ReactNode
}

/**
 * A `FieldLabel` (label-at-top) paired with an MUI `Select` in a full-width
 * `FormControl`. The standard admin add/edit dropdown - use instead of an
 * `InputLabel` + floating-label `Select`. `displayEmpty` is on so the control
 * renders without a floating label; pass a placeholder `<MenuItem value="">`.
 */
const LabeledSelect: React.FC<LabeledSelectProps> = ({
  label,
  required = false,
  helperText,
  children,
  ...selectProps
}) => (
  <>
    <FieldLabel required={required}>{label}</FieldLabel>
    <FormControl fullWidth required={required}>
      <Select displayEmpty {...selectProps}>
        {children}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  </>
)

export default LabeledSelect
